export const LINK_MARKER = { name: "src", value: "link" } as const;

export function markLink(params: URLSearchParams): URLSearchParams {
  params.set(LINK_MARKER.name, LINK_MARKER.value);
  return params;
}

export function toolLinkHref(path: string, params: Record<string, string>): string {
  return `${path}?${markLink(new URLSearchParams(params))}`;
}

export function isLinkVisit(search: string): boolean {
  return new URLSearchParams(search).get(LINK_MARKER.name) === LINK_MARKER.value;
}

export function keepLinkMarker(params: URLSearchParams, currentSearch: string): URLSearchParams {
  return isLinkVisit(currentSearch) ? markLink(params) : params;
}
